import React, { useState, useEffect } from 'react';
// import api from '@/services/api';
import { Trophy } from 'lucide-react';
import './Achievements.css';
import TabNavigation from '@/components/achievements/TabNavigation';
import OverviewTab from '@/components/achievements/OverviewTab';
import BadgesTab from '@/components/achievements/BadgesTab';
import PassportTab from '@/components/achievements/PassportTab';

const Achievements = () => {
  const [activeTab, setActiveTab] = useState('overview');

  // Check URL hash on mount and when it changes
  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash === 'passport' || hash === 'badges' || hash === 'overview') {
      setActiveTab(hash);
    }
  }, []);
  
    // const passports = api.get(`passports`);
    // const badges = api.get(`badges`);

    // const verifyPassport = (uniqueCode) => api.get(`/passports/verify/${uniqueCode}`);
    // const verifyBadge = (uuid) => api.get(`/badges/verify/${uuid}`);

  return (
    <div className="achievements-container text-start">
      <header className="achievements-header">
        <h1 className="block">
          <Trophy size={32} className="inline -mt-2 mr-4 text-yellow-400"/>
          Achievements
        </h1>
      </header>

      <TabNavigation activeTab={activeTab} setActiveTab={setActiveTab} />

      <div className="tab-content">
        {activeTab === 'overview' && <OverviewTab setActiveTab={setActiveTab} />}
        {activeTab === 'badges' && <BadgesTab />}
        {activeTab === 'passport' && <PassportTab />}
      </div>
    </div>
  );
};

export default Achievements;